import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'locationString',
  standalone: true
})
export class LocationStringPipe implements PipeTransform {
  transform(location: string | string[] | null | undefined): string {
    if (!location) return '';
    return Array.isArray(location) ? location.join(', ') : location;
  }
}
